import AmdrTemplateCreation from "./AmdrTemplateCreation";

export default AmdrTemplateCreation;
